<ng-container *ngIf="{ data: data$ | async } as resolved">
  <mat-form-field
    *ngIf="filterEnabled"
    subscriptSizing="dynamic"
    class="tw-w-full tw-pb-0 tw-mb-0">
    <mat-label>{{ labels.search }}</mat-label>
    <input
      matInput
      (keyup)="applyFilter($event)">
  </mat-form-field>
  <div
    *ngIf="uiFramework === 'material'"
    class="table-scroll-wrapper"
    [class.table-scroll-wrapper--fixed]="tableLayout === 'fixed'">
  <table
    class="customer-table"
    [class.customer-table--fixed-layout]="tableLayout === 'fixed'"
    mat-table
    multiTemplateDataRows
    matSort
    [dataSource]="dataSource"
    (matSortChange)="onSortChange($event)">
    <ng-container
      *ngFor="let column of visibleColumns; let i = index; trackBy: trackByColumn"
      [matColumnDef]="column.columnDef"
      [sticky]="column.sticky === 'start' || (!hasAnyStickyConfig && i === 0)"
      [stickyEnd]="column.sticky === 'end'">
      <th
        *matHeaderCellDef
        mat-header-cell
        class="text-grey-400"
        [ngClass]="column.headerClass"
        [class.sticky-col]="column.sticky === 'start' || column.sticky === 'end' || (!hasAnyStickyConfig && i === 0)"
        [mat-sort-header]="column.sortable ? column.columnDef : ''">
        <ng-container *ngIf="column.headerTemplate; else headerLabel">
          <ng-container *ngTemplateOutlet="column.headerTemplate; context: { $implicit: column }"></ng-container>
        </ng-container>
        <ng-template #headerLabel>{{ column.header }}</ng-template>
      </th>
      <td
        *matCellDef="let row"
        class="text-grey-400"
        mat-cell
        [ngClass]="column.cellClass"
        [class.sticky-col]="column.sticky === 'start' || column.sticky === 'end' || (!hasAnyStickyConfig && i === 0)"
        [ngStyle]="{ 'cursor': column.cellOutput ? 'pointer' : 'default' }"
        (click)="column.cellOutput && column.cellOutput(row)">
        <div
          class="table-cell-content"
          [class.has-expansion-icon]="showRowExpansionIcon && i === 0 && getRowExpansionTemplate(row)">
          <ng-container *ngTemplateOutlet="rowTemplate; context: { row: row, column: column, toggleRowExpansion: toggleRowExpansionFn, isRowExpanded: isRowExpandedFn }"></ng-container>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" [attr.colspan]="visibleColumnNames.length">
        <ng-container *ngIf="isRowExpanded(row)">
          <ng-container *ngIf="getRowExpansionTemplate(row) as tpl">
            <ng-container *ngTemplateOutlet="tpl; context: { $implicit: row }"></ng-container>
          </ng-container>
        </ng-container>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="visibleColumnNames" mat-header-row></tr>
    <tr
      *matRowDef="let row; columns: visibleColumnNames; let odd = odd"
      mat-row
      class="hover"
      [ngClass]="{
        'bg-grey-100': !row?.selected && odd,
        'bg-accent-100': row?.selected,
        'expanded': isRowExpanded(row)
      }"
      [ngStyle]="{ 'cursor': rowClickable || getRowExpansionTemplate(row) ? 'pointer' : 'default' }"
      (click)="rowClickable && rowClickable(row); allowRowClickExpansion && toggleRowExpansion(row)">
    </tr>
    <tr
      *matRowDef="let row; columns: ['expandedDetail']; when: isExpansionDetailRow; let last = last"
      mat-row
      class="block-bg-contrast border-grey-200"
      [class.border-b-1]="!last">
    </tr>
    <tr
      *matNoDataRow
      mat-no-data-row>
      <td class="tw-text-center tw-font-medium tw-p-2 text-grey-400 py-10"
          [attr.colspan]="visibleColumnNames.length">
        <ng-container *ngIf="noResultTemplate; else defaultNoResult">
          <ng-container *ngTemplateOutlet="noResultTemplate"></ng-container>
        </ng-container>
        <ng-template #defaultNoResult>
          {{ labels.noResults }}
        </ng-template>
      </td>
    </tr>
  </table>
  </div>
  <section
    *ngIf="uiFramework === 'ionic'"
    class="tw-border-grey-100 border-1 radius-4">
    <ng-container *ngIf="dataSource.data.length > 0; else noDataIonic">
      <ng-container *ngFor="let row of dataSource.data; let odd = odd">
        <section
          class="p-3 fx-col fx-gap-1"
          [class.expanded]="isRowExpanded(row)"
          [ngClass]="{ 'bg-grey-100': odd }"
          [ngStyle]="{ 'cursor': rowClickable || getRowExpansionTemplate(row) ? 'pointer' : 'default' }"
          (click)="rowClickable && rowClickable(row); allowRowClickExpansion && toggleRowExpansion(row)">
          <ng-container *ngFor="let column of visibleColumns; let i = index">
            <div
              class="fx-row fx-align-center fx-justify-between min-h-9 text-grey-400"
              [ngClass]="column.cellClass">
              <div
                class="ellipsed pr-3 min-w-30"
                [class.w-full]="loading">
                {{ column.header }}
              </div>
              <div
                class="table-cell-content"
                [class.has-expansion-icon]="showRowExpansionIcon && i === 0 && getRowExpansionTemplate(row)">
                <ng-container *ngTemplateOutlet="rowTemplate; context: { row: row, column: column, toggleRowExpansion: toggleRowExpansionFn, isRowExpanded: isRowExpandedFn }">
                </ng-container>
              </div>
            </div>
          </ng-container>
          <section
            *ngIf="isRowExpanded(row)"
            class="pt-3">
            <ng-container *ngIf="getRowExpansionTemplate(row) as tpl">
              <ng-container *ngTemplateOutlet="tpl; context: { $implicit: row }"></ng-container>
            </ng-container>
          </section>
        </section>
      </ng-container>
    </ng-container>
    <ng-template #noDataIonic>
      <div class="tw-text-center tw-font-medium tw-p-2 text-grey-400 py-10">
        <ng-container *ngIf="noResultTemplate; else defaultNoResultIonic">
          <ng-container *ngTemplateOutlet="noResultTemplate"></ng-container>
        </ng-container>
        <ng-template #defaultNoResultIonic>
          {{ labels.noResults }}
        </ng-template>
      </div>
    </ng-template>
  </section>
  <div
    *ngIf="pagination || showColumnToggleButton"
    class="fx-row bg-white fx-justify-between fx-align-center">
    <div class="fx-g-1 fx-row fx-justify-end">
      <mat-paginator
        *ngIf="pagination"
        class="text-grey-400"
        [disabled]="loading"
        [pageSizeOptions]="paginationConfig?.pageSizeOptions || []"
        [pageSize]="paginationConfig?.pageSize"
        [length]="mode === 'client' ? dataSource.data.length : paginationConfig?.length"
        (page)="onPageChange($event)">
      </mat-paginator>
    </div>
    <button
      *ngIf="showColumnToggleButton"
      mat-icon-button
      tooltipMode="click"
      tooltip
      [tooltipTemplate]="columnsSelectionTemplate"
      [tooltipPosition]="tooltipsTemplatePosition">
      <mat-icon style="color: var(--grey-400)">settings</mat-icon>
    </button>
  </div>
</ng-container>

<ng-template #columnsSelectionTemplate>
  <section class="p-2 bg-white border-1 border-grey-200 radius-4">
    <p class="tw-font-medium text-grey-400"> {{ labels.selectColumns }} </p>
    <div *ngFor="let column of columns">
      <mat-checkbox
        class="custom-checkbox"
        [checked]="!column.hidden"
        (change)="toggleColumnVisibility(column.columnDef)">
        {{ column.header }}
      </mat-checkbox>
    </div>
  </section>
</ng-template>

<ng-template
  #rowTemplate
  let-row="row"
  let-column="column"
  let-toggleRowExpansion="toggleRowExpansion"
  let-isRowExpanded="isRowExpanded">
  <ng-container *ngIf="!loading; else skeletonCell">
    <ng-container [ngSwitch]="column.type">
      <ng-container *ngSwitchCase="'text'">
        <ng-container *ngIf="column.type === 'text' && (column.cellHidden ? !(row | apply: column.cellHidden) : true)">
          <ng-container *ngIf="{
            cellValue: column.cell$
              ? (row | apply: column.cell$ | async)
              : column.cell
                ? (row | apply: column.cell)
                : '',
            tooltip: column.tooltip$
              ? (row | apply: column.tooltip$ | async)
              : column.tooltip
                ? (row | apply: column.tooltip)
                : ''
            } as resolved">
            <span class="cell-text" [matTooltip]="$any(resolved.tooltip) || ''">
              {{ resolved.cellValue }}
            </span>
          </ng-container>
        </ng-container>
      </ng-container>
      <!-- Chip Type Column-->
      <ng-container *ngSwitchCase="'chip'">
        <ng-container *ngIf="column.type === 'chip' && (column.cellHidden ? !(row | apply: column.cellHidden) : true)">
          <ng-container *ngIf="{
            chipColor: column.chipColor$
              ? (row | apply: column.chipColor$ | async)
              : column.chipColor
                ? (row | apply: column.chipColor)
                : 'primary',
            cellValue: column.cell$
              ? (row | apply: column.cell$ | async)
              : column.cell
                ? (row | apply: column.cell)
                : '',
            tooltip: column.tooltip$
              ? (row | apply: column.tooltip$ | async)
              : column.tooltip
                ? (row | apply: column.tooltip)
                : ''
            } as resolved">
            <mat-chip
              [matTooltip]="$any(resolved.tooltip) || ''"
              [ngClass]="{
                'chip-level-0': resolved.chipColor === ColorTypeEnum.Primary,
                'chip-level-1': resolved.chipColor === ColorTypeEnum.Yellow,
                'chip-level-2': resolved.chipColor === ColorTypeEnum.Red,
                'chip-level-3': resolved.chipColor === ColorTypeEnum.Green,
              }">
              {{ resolved.cellValue }}
            </mat-chip>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'icon'">
        <ng-container *ngIf="column.type === 'icon' && (column.cellHidden ? !(row | apply: column.cellHidden) : true)">
          <ng-container *ngIf="{
            iconColor: column.color$
              ? (row | apply: column.color$ | async)
              : column.color
                ? (row | apply: column.color)
                : '',
            cellValue: column.cell$
              ? (row | apply: column.cell$ | async)
              : column.cell
                ? (row | apply: column.cell)
                : '',
            tooltip: column.tooltip$
              ? (row | apply: column.tooltip$ | async)
              : column.tooltip
                ? (row | apply: column.tooltip)
                : ''
            } as resolved">
            <mat-icon
              [matTooltip]="$any(resolved.tooltip) || ''"
              [ngClass]="{
                'icon-warning': resolved.iconColor === ColorTypeEnum.Yellow,
                'icon-error': resolved.iconColor === ColorTypeEnum.Red,
                'icon-success': resolved.iconColor === ColorTypeEnum.Green,
                'icon-accent': resolved.iconColor === ColorTypeEnum.Primary,
              }">
              {{ resolved.cellValue }}
            </mat-icon>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'date'">
        <ng-container *ngIf="column.type === 'date' && (column.cellHidden ? !(row | apply: column.cellHidden) : true)">
          <ng-container *ngIf="{
            cellValue: column.cell$
              ? (row | apply: column.cell$ | async)
              : column.cell
                ? (row | apply: column.cell)
                : null,
            tooltip: column.tooltip$
              ? (row | apply: column.tooltip$ | async)
              : column.tooltip
                ? (row | apply: column.tooltip)
                : ''
            } as resolved">
            <span class="cell-text">
              {{ $any(resolved.cellValue) | date: (column.format || 'shortDate') }}
            </span>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'template'">
        <ng-container *ngIf="column.type === 'template'">
          <ng-container *ngTemplateOutlet="column.template; context: { $implicit: row, toggleRowExpansion: toggleRowExpansion, isRowExpanded: isRowExpanded }"></ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngIf="column.type !== 'template'">
          <ng-container *ngIf="{
            cellValue: column.cell$
              ? (row | apply: column.cell$ | async)
              : column.cell
                ? (row | apply: column.cell)
                : '',
            tooltip: column.tooltip$
              ? (row | apply: column.tooltip$ | async)
              : column.tooltip
                ? (row | apply: column.tooltip)
                : ''
            } as resolved">
            <span class="cell-text">
              {{ resolved.cellValue }}
            </span>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-template #skeletonCell>
    <ion-skeleton-text animated class="w-full h-10"></ion-skeleton-text>
  </ng-template>
</ng-template>
